import React from "react";
import { GM_Point } from "../../shared-types/WeatherTypes";
import { Feature, Polygon, MultiPolygon } from "geojson";

export type TropicalStormsContextType = {
  isLoaded: boolean;
  isLoading: boolean;
  storms: TropicalStorm[];
};

export type TropicalStorm = {
  basinID: string;
  classification: string;
  publishingCenter: string;
  name: string;
  warningNumber: number;
  positions: TropicalStormPosition[];
  windDangerSwath?: TropicalStormWindDangerSwath;
  coneOfUncertainty?: TropicalStormConeOfUncertainty;
};

export type TropicalStormWindDangerSwath = Feature<Polygon | MultiPolygon>;
export type TropicalStormConeOfUncertainty = Feature<Polygon>;

export type TropicalStormClassification =
  | "Depression"
  | "Tropical Storm"
  | "Severe Tropical Storm"
  | "Hurricane"
  | "Severe Hurricane";

export type TropicalStormPosition = {
  position: GM_Point;
  forecastDayHour: string;
  forecastDateTime: string;
  forecastHour: number;
  gustSpeedKnots: number;
  maxSignificantWaveHeightMeters: string;
  movementDeg: number;
  movementKnots: number;
  nextForecastHour: number;
  windSpeedKnots: number;
  windQuadrants: WindQuadrant[];
  classification: TropicalStormClassification;
};

export type WindQuadrant = {
  windSpeedKnots: number;
  NE?: WindQuadrantValue;
  NW?: WindQuadrantValue;
  SE?: WindQuadrantValue;
  SW?: WindQuadrantValue;
};

export type WindQuadrantValue = {
  description: string;
  radiusNauticalMiles: number;
};

const tropicalStormsContextDefault: TropicalStormsContextType = {
  isLoaded: false,
  isLoading: false,
  storms: [],
};

export const TropicalStormsContext =
  React.createContext<TropicalStormsContextType>(tropicalStormsContextDefault);
